// "Add to Home Screen" helpers.
// Chromium browsers (Android, desktop) fire `beforeinstallprompt` when the app is installable;
// we keep the event so a button can open the native install dialog later.
// iOS has no such API — the user must use Share → Add to Home Screen, so we can only explain it.
// Imported from index.js so the listener is registered before the event can fire.

let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach(fn => fn());

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();          // suppress Chrome's own mini-infobar; we show our banner instead
  deferredPrompt = e;
  notify();
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  notify();
});

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

// iPadOS reports itself as a Mac — tell it apart by touch support
export const isIos = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (/macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

export const isMobile = () => isIos() || /android/i.test(navigator.userAgent);

export const canPromptInstall = () => deferredPrompt !== null;

// Opens the native install dialog; resolves true if the user accepted
export async function promptInstall() {
  if (!deferredPrompt) return false;
  const e = deferredPrompt;
  deferredPrompt = null;       // the event can only be used once
  notify();
  await e.prompt();
  const { outcome } = await e.userChoice;
  return outcome === 'accepted';
}

export function subscribeInstall(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
